export const assignIdsBasedOnTime = sortedPriceSettings => {
	return sortedPriceSettings.map((item, index) => {
		return { ...item, id: index + 1 }
	})
}
